export { default as routes } from './routes'
export { default as vuex } from './vuex'



// WEBPACK FOOTER //
// ./src/app/index.js